import { Box, Button, FormControlLabel, Grid, IconButton, Typography } from "@mui/material"
import { icons } from "../../../../../../utils/icons"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { IOSSwitch } from "../../../../../../components/dynamicFormRef/switch"
import { inputModel } from "../../../main/initialState"
import { PropsConfigSerieCalendar } from "./types"
import { SectionType } from "../../enums"
import { useNavigate } from "react-router-dom"
import { ScheduleTypeSerie } from "../scheduleTypeSerie"
import { ScheduleEnumType } from "../../../form/components/steps/configCalendar/enums"

const ConfigCalendarSerie = ({
  stringToNavigate,
  setSteps,
  secondButonTitle,
  firstInput,
  secondText,
  data,
  titelForm,
  errors,
  disabled,
  maxToDay,
  assignedChildren,
  onChange,
  setSection,
  setModal,
  scheduleType,
  selectedText,
  userOption,
  mimTimeZone,
  refRange,
  selectedDays,
  setData,
  setSelectedDays,
  setStartDate,
  startDate,
}: PropsConfigSerieCalendar) => {
  const styles = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Box>
      <Box>
        <Box sx={styles.headerLeft}>
          <IconButton
            onClick={() => {
              setModal((prev) => ({
                ...prev,
                open: true,
                children: undefined,
                title: t("schedule.modal.backToTheList"),
                description: t("schedule.modal.sureBackToTheList"),
                confirm: () => {
                  navigate(stringToNavigate)
                },
                isLoading: false,
              }))
            }}
          >
            {icons("arrow-left-fill")}
          </IconButton>
          <Typography>{t("schedule.assigned.backToList")}</Typography>
        </Box>

        <Box>
          <Typography sx={styles.title}>
            {scheduleType !== ScheduleEnumType.SERIE ? t("schedule.assigned.calendarEdit") : t("schedule.assigned.editCalendarSeries")}
          </Typography>
        </Box>
      </Box>

      <Grid container sx={styles.gridContainer} spacing={3}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={4}>
          <Box sx={styles.flexGp2}>
            <Box sx={styles.flex}>
              <Typography variant="text_grey" fontWeight={"bold"} fontSize={18}>
                {titelForm}
              </Typography>
              <DinamicForm input={Object.values(firstInput)} values={data} onChange={onChange} errors={errors} />
            </Box>

            <Box sx={styles.flex}>
              <Typography variant="text_grey" fontWeight={"bold"} fontSize={18}>
                {t("schedule.assigned.notification")}
              </Typography>

              <Box>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      name="notifiedAdmin"
                      checked={!!data.notifiedAdmin}
                      onChange={({ target }) => {
                        onChange({
                          target: {
                            name: target.name,
                            value: target.checked,
                          },
                        })
                      }}
                      sx={{ m: 1 }}
                    />
                  }
                  sx={styles.switch}
                  label={t("schedule.assigned.sendAlertToAdminSecond")}
                />
              </Box>

              <Box>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      name="notified"
                      checked={!!data.notified}
                      onChange={({ target }) => {
                        onChange({
                          target: {
                            name: target.name,
                            value: target.checked,
                          },
                        })
                      }}
                      sx={{ m: 1 }}
                    />
                  }
                  sx={styles.switch}
                  label={t("schedule.assigned.sendAlertSecond")}
                />
              </Box>
            </Box>

            <Box sx={styles.flex}>
              <Typography variant="text_grey" fontWeight={"bold"} fontSize={18}>
                {t("schedule.assigned.questionarie")}
              </Typography>
              <Box>
                <Typography sx={styles.text}>{selectedText.questionnaire}</Typography>
                <Button
                  sx={styles.button}
                  onClick={() => {
                    if (setSteps) {
                      setSteps(1)
                    }
                    setSection(SectionType.Questionarie)
                  }}
                >
                  {t("schedule.buttons.selectOtherQuestionarie")}
                </Button>
              </Box>
            </Box>

            {/* ✅ UNIDAD + ESTADO COLOREADO AL LADO */}
            <Box sx={styles.flex}>
              <Typography variant="text_grey" fontWeight={"bold"} fontSize={18}>
                {secondText}
              </Typography>
              <Box>
                <Typography sx={styles.text} component="div">
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, minWidth: 0, flexWrap: "wrap" }}>
                    <Box component="span" sx={{ minWidth: 0 }}>
                      {selectedText.stores}
                    </Box>

                    <Box component="span" sx={{ opacity: 0.9 }}>
                      {" - "}
                    </Box>

                    <Box
                      component="span"
                      sx={{
                        color: selectedText?.storeStatusColor || "text.secondary",
                        fontSize: "0.92em",
                        fontWeight: "inherit",
                        lineHeight: "inherit",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {selectedText?.storeStatusText || "N/A"}
                    </Box>
                  </Box>
                </Typography>

                <Button
                  sx={styles.button}
                  onClick={() => {
                    if (setSteps) {
                      setSteps(0)
                    }
                    setSection(SectionType.Unity)
                  }}
                >
                  {secondButonTitle}
                </Button>
              </Box>
            </Box>

            {userOption && (
              <Box sx={styles.flex}>
                <Typography variant="text_grey" fontWeight={"bold"} fontSize={18}>
                  {t("general.tags.assignedUser")}
                </Typography>
                <DinamicForm input={Object.values(userOption)} values={data} onChange={onChange} errors={errors} />
              </Box>
            )}
          </Box>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={6} xl={4}>
          <Box sx={styles.containerRightGrid}>
            <ScheduleTypeSerie
              data={data}
              errors={errors}
              inputModel={inputModel}
              mimTimeZone={mimTimeZone}
              onChange={onChange}
              refRange={refRange}
              scheduleType={scheduleType}
              selectedDays={selectedDays}
              setData={setData}
              setSelectedDays={setSelectedDays}
              setStartDate={setStartDate}
              startDate={startDate}
              maxToDay={maxToDay}
            />
          </Box>
        </Grid>

        <Grid xs={12}>
          <Box sx={styles.containerChildButtons(!!userOption)}>
            <Button
              onClick={() => {
                setModal((prev) => ({
                  ...prev,
                  open: true,
                  children: undefined,
                  title: t("schedule.modal.cancelEdition"),
                  description: t("schedule.modal.cancelEditionDescription"),
                  confirm: () => {
                    navigate(stringToNavigate)
                  },
                  isLoading: false,
                }))
              }}
              sx={styles.cancelButton}
            >
              {t("useScheduled.detail.buttons.cancel")}
            </Button>

            <Button
              disabled={disabled()}
              sx={styles.aceptButton}
              onClick={() => {
                assignedChildren()
              }}
              variant="contained"
            >
              {t(`general.save`)}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export { ConfigCalendarSerie }
